import { createSlice } from '@reduxjs/toolkit';
const slice = createSlice({
    name: 'leadForm',
    initialState: { leadFormData: null, selectedLocationPreference: null },
    reducers: {
        setLeadFormData: (state, { payload }) => {
            state.leadFormData = payload.leadFormData;
            state.selectedLocationPreference = payload.selectedLocationPreference;
        },
        clearLeadFormData: (state) => {
            state.leadFormData = null;
            state.selectedLocationPreference = null;
        }
    },
});
export const { setLeadFormData, clearLeadFormData } = slice.actions;
export default slice.reducer;
export const selectLeadFormData = (state) => state.leadForm.leadFormData;
export const selectSelectedLocationPreference = (state) => state.leadForm.selectedLocationPreference;
